const VERSION = '1.1.7';
export default VERSION;
